import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

const ProductBadge = ({ tags, className }) => {
  const [badge, setBadge] = useState(null);

  useEffect(() => {
    if (!tags || !tags.length) return;
    const badges = tags.filter((tag) => tag.split('::')[0] === 'badge');

    if (badges.length) {
      setBadge(badges[0].split('::')[1]);
    } else {
      setBadge(null);
    }
  }, [tags]);

  return (
    badge && (
      <div
        className={
          className
            ? `${className}`
            : 'absolute z-50 left-0 top-5 px-[10px] py-[5px] bg-pantone-8 text-black text-product-tag max-h-[26px] flex items-center lg:left-5'
        }
      >
        {badge}
      </div>
    )
  );
};

export default ProductBadge;
